import * as React from 'react';
import { Tree } from 'primereact/tree';

const anatomicalSystemView = (props) => {

	return (
		<Tree
			value={props.treeAnatomicalSystems}
			style={{ width: "100%" }}
			selectionMode="single"
			selectionKeys={props.selectionKeys}
			onSelectionChange={e => props.handleSelectionChange(e.value)}
			onContextMenu={props.onContextMenu}
		/>
	)
}

export default anatomicalSystemView;
